import { render, staticRenderFns } from "./TaxadeComissao.vue?vue&type=template&id=8cd52d66&scoped=true"
import script from "./TaxadeComissao.vue?vue&type=script&lang=js"
export * from "./TaxadeComissao.vue?vue&type=script&lang=js"
import style0 from "./TaxadeComissao.vue?vue&type=style&index=0&id=8cd52d66&prod&lang=css"
import style1 from "./TaxadeComissao.vue?vue&type=style&index=1&id=8cd52d66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cd52d66",
  null
  
)

export default component.exports